import GiftNotes from '@components/gift/GiftNotes';
import { ENCOFFEE_GIFT_NOTES, GIFT_USAGE_NOTE } from '@components/gift/GiftNotes/notes';
import PrepaidCardNotes from '@components/prepaid/PrepaidCardNotes';
import { ENCOFFEE_PROJECT_IDS } from '@constants/projects';
import useProjectId from '@hooks/useProjectId';
import { GiftItemType } from '@models/gift';

interface Props {
    giftItemType: `${GiftItemType}`;
}

/** 선불카드 선물은 선불카드 유의사항, 상품 선물은 선물하기 유의사항 노출 */
function GiftTypeNotes({ giftItemType }: Props) {
    const isEncoffee = ENCOFFEE_PROJECT_IDS.includes(useProjectId());

    if (giftItemType === GiftItemType.CASH) {
        return <PrepaidCardNotes noMargin />;
    }
    return <GiftNotes notes={isEncoffee ? ENCOFFEE_GIFT_NOTES : [GIFT_USAGE_NOTE]} />;
}

export default GiftTypeNotes;
